import React, { useEffect } from "react";
import TagManager from "react-gtm-module";

import AppProviders from "./config/AppProviders";
import ChatTwillo from "./config/ChatTwillo";
import GlobalStyle from "./styles/global";
import Routes from "./routes";
import TourOverlay from "components/NewTour/TourOverlay";
import Ully from "components/Ully";
import firebaseInitialize from "./services/firebase";
import { LEGACY_DIRECTTALK_ENABLED } from "components/Ully/constants";
import { PesquisaMarcaIndecx } from "components/Portal/PesquisaMarcaIndecx";

const App = (): JSX.Element => {
  useEffect(() => {
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
    });
    firebaseInitialize.analytics();

    const script = document.createElement("script");

    if (
      process.env.REACT_APP_ENV === "build-prod" ||
      process.env.REACT_APP_ENV === "prod"
    ) {
      script.type = "text/javascript";
      script.src =
        "https://js-cdn.dynatrace.com/jstag/1624d0f62e6/bf82227shx/d17559510b127308_complete.js";
      script.async = true;
      document.body.appendChild(script);
    }

    return () => {
      document?.body?.removeChild(script);
    };
  }, []);

  return (
    <AppProviders>
      <Routes />
      <GlobalStyle />
      {LEGACY_DIRECTTALK_ENABLED ? <ChatTwillo /> : <Ully />}
      <TourOverlay />
      <PesquisaMarcaIndecx />
    </AppProviders>
  );
};

export default App;
